import {combineReducers} from "redux";

import areaStore from './areaStore'
import featureStore from './featureStore'

const rootReducer = combineReducers({
    areaStore : areaStore,
    featureStore : featureStore
})

export default rootReducer;
